export default __webpack_public_path__ + "static/media/Illustration.dd60108b.svg";